import { css } from '@emotion/css';
import { colors } from './../../../constants/theme';

const loginHeaderStyle = {
    right: css`
        display: flex;
    `,
    formLogin: css`
        display: flex;
        gap: 7px;
    `,
    inputAccount: css`
        align-items: center;
    `,
    bgForm: css`
        /* background: ${colors.bgTitle}; */
        /* padding: 2px 4px; */
        /* border-radius: 12px; */
    `,
    inputWrap: css`
        display: flex;
        align-items: center;
        padding: 0 8px;
        border-width: 1;
        border: 1.2px solid ${colors.borderPrimary};
        border-radius: 4px;
    `,
    input: css`
        border: none;
        background: none;
        margin-left: 8px;
        padding: 8px 0;
        width: 130px;
        height: 32px;
        font-size: 14px;
        &:placeholder-shown {
            font-size: 14px;
            transform: translateY(1px);
        }
        color: ${colors.white};
    `,

    buttonLogin: css`
        background: transparent;
        border: 1.2px solid ${colors.borderPrimary};
        color: ${colors.white};
        transition:
            background 0.25s ease-in-out,
            border-color 0.25s ease-in-out;
        border-radius: 4px;
        padding-left: 10px;
        padding-right: 10px;
        font-family: 'UTM Avo' !important;
        font-weight: 300 !important;
        &:hover {
            background: rgba(124, 148, 234, 0.15);
        }
    `,
    buttonRegister: css`
        background: linear-gradient(to bottom, #ffe08a 0%, #ffad33 100%);
        border: 1.2px solid #c9820a;
        color: ${colors.blackText};
        transition: filter 0.25s ease-in-out;
        border-radius: 4px;
        padding-left: 10px;
        padding-right: 10px;
        font-family: 'UTM Avo' !important;
        font-weight: 500 !important;
        &:hover {
            filter: brightness(1.05);
        }
    `,
    icon: css`
        height: 14px;
        width: 14px;
        object-fit: contain;
    `,
    remember: css`
        display: flex;
        align-items: center;
        margin-top: 7px;
        label {
            margin-left: 3px;
            font-size: 12px;
            color: #dedede;
        }
    `,
    forgetPw: css`
        color: #dedede;
        font-size: 14px;
        cursor: pointer;
        padding-right: 8px;
        margin-left: 4px;
        text-decoration: underline;
        margin-top: 10px;
    `,
    togglePw: css`
        cursor: pointer;
        display: flex;
        height: 100%;
        align-items: center;
        img {
            width: 18px;
        }
    `,
    btnGroup: css`
        display: flex;
        gap: 10px;
        margin-left: 10px;
        button {
            height: 35px;
        }
    `,
};
export default loginHeaderStyle;
